namespace RedBullMOBILE360.LoanWhitelist {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.LoanWhitelist.LoanWhitelistGrid')
    export class LoanWhitelistGrid extends Serenity.EntityGrid<LoanWhitelistRow, any> {
        protected getColumnsKey() { return LoanWhitelistColumns.columnsKey; }
        protected getDialogType() { return LoanWhitelistDialog; }
        protected getIdProperty() { return LoanWhitelistRow.idProperty; }
        protected getInsertPermission() { return LoanWhitelistRow.insertPermission; }
        protected getLocalTextPrefix() { return LoanWhitelistRow.localTextPrefix; }
        protected getService() { return LoanWhitelistService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            //if (!Q.Authorization.userDefinition.IsAdmin)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push({
                title: 'Add new number',
                cssClass: 'import-button',
                onClick: () => {
                    var dialog = new LoanWhitelistDialog();
                    dialog.dialogOpen();
                }
            });

            buttons.push({
                title: 'Import List of numbers',
                cssClass: 'import-button',
                onClick: () => {
                    var dialog = new LoanWhitelistImportDialog();
                    dialog.dialogOpen();
                }
            });

            return buttons;
        }
    }
}